import { FC } from 'react'

import { ContentCardProps } from '../ContentCard'
import { ContentCardGroupProps } from '../ContentCardGroup'

import * as SC from './styled'

export type ContentCardsProps = {
  items: (ContentCardProps | ContentCardGroupProps)[]
}

const ContentCards: FC<ContentCardsProps> = ({ items }) => {
  return (
    <SC.Cards>
      {items?.map((item: any) => {
        return typeof item?.cards !== 'undefined' ? (
          <SC.CardsGroup
            key={item?.cards[0]?.secondHighlightText ?? ''}
            {...(item as ContentCardGroupProps)}
          ></SC.CardsGroup>
        ) : (
          <SC.Card
            {...(item as ContentCardProps)}
            key={item?.secondHighlightText ?? ''}
          ></SC.Card>
        )
      })}
    </SC.Cards>
  )
}

export default ContentCards
